module.exports = __webpack_public_path__ + "img/flower.85789d15.png";